import { number } from "prop-types";

import classes from "./ProgressRing.module.scss";

const SIZE = 132;
const STROKE = 10;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const CENTER = SIZE / 2;

const ProgressRing = ({ progress = 0 }) => {
  const pct = Math.max(0, Math.min(100, Math.round(progress)));
  const offset = CIRCUMFERENCE * (1 - pct / 100);

  return (
    <div
      className={classes["ring"]}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Overall generation progress"
    >
      <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
        <circle
          className={classes["ring__track"]}
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          strokeWidth={STROKE}
          fill="none"
        />
        <circle
          className={classes["ring__fill"]}
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          strokeWidth={STROKE}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${CENTER} ${CENTER})`}
        />
      </svg>
      <div className={classes["ring__label"]}>
        <span className={classes["ring__pct"]}>{pct}%</span>
        <span className={classes["ring__caption"]}>complete</span>
      </div>
    </div>
  );
};

ProgressRing.propTypes = {
  progress: number,
};

export default ProgressRing;
